import styles from './teamCard.module.css';
import { useNavigate, useLocation } from "react-router-dom";
import { forceReload } from '../FussballDeWidget/FussballDeWidget';
import { getBackgroundColor } from '../../../code/ColorHandler';
function TeamCard({ item }) {
    const navigate = useNavigate();
    const location = useLocation();
    const handleClick = (link) => {
        if (link.startsWith("/")) {
            if (forceReload(link)) {
                window.location.href = link
            } else {
                navigate(link);
            }
        } else {
            window.open(link, "_blank");
        }
    };

    const renderImageOrIcon = () => {
        if (typeof item.img === 'string') {
            return <img className={styles.teamBild} src={item.img} alt={item.altText} />;
        } else if (typeof item.img === 'function') {
            const IconComponent = item.img;
            return <IconComponent className={styles.teamIcon} aria-label={item.altText} />;
        }
        return null;
    };
    return (
        <div
            tabIndex={0}
            className={styles.team}
            style={{ backgroundColor: getBackgroundColor(location) }}
            onClick={() => handleClick(item.link)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // Prevent space from scrolling
                    handleClick(item.link)
                }
            }}>
            <div className={styles.imgWrapper}>
                {renderImageOrIcon()}
            </div>
            <div className={styles.teamTexte}>
                {item.team && <p className={styles.teamText}>{item.team}</p>}
                {item.liga && <p className={styles.ligaText}>{item.liga}</p>}
            </div>
        </div>
    );
}

export default TeamCard;